import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { ThumbnailBig, FooterSection, SimpleMenu } from '@components'
import './TentangCorporateGovernance.scss'
import { CorporateGovernanceAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import MyMenu from '../MyMenu'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const CorporateGovernanceContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`

const Img = styled.img`
  width: 100%;
  height: 450px;
  object-fit: cover;
  margin: 0px auto;
  @media (max-width: 768px) {
    height: 300px;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const TentangCorporateGovernance = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async function () {
    setisLoading(true)
    const { data } = await CorporateGovernanceAPI('tentang')
    setdata(data.data)
    setisLoading(false)
  }

  return (
    <div>
      <TitleComponent title={data.judulBannerTentang} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerTentang}
            desc={isLoading ? '' : data.deskripsiBannerTentang}
            img={isLoading ? '' : data.imageBannerDesktopTentang}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerTentang}
            desc={isLoading ? '' : data.deskripsiBannerTentang}
            img={isLoading ? '' : data.imageBannerMobileTentang}
          />
        </Mobile>
      </Container>

      <CorporateGovernanceContainer className="container-fluid">
        <div className="m-0 row">
          <div className="p-0 col-lg-9 col-12">
            <Desktop>
              <Img className="mb-4" src={data.imageDataDesktopTentang} />
            </Desktop>
            <Mobile>
              <Img className="mb-4" src={data.imageDataMobileTentang} />
            </Mobile>
            <p
              dangerouslySetInnerHTML={{ __html: data.deskripsiDataTentang }}
            ></p>
          </div>
          <div className="d-none d-lg-block col">
            <MyMenu active={0} />
          </div>
        </div>
      </CorporateGovernanceContainer>
      <FooterSection currentPage={t('tentang_tata_kelola_perusahaan')} />
    </div>
  )
}

export default TentangCorporateGovernance
